<div class="page-container">
    <div fxLayout="column">
        <app-page-header [section]="'Atoku'" [title]="'Access Management'"
            [description]="'Manage user subscription and access block state.'"></app-page-header>

        <div class="page-padding page-content full-screen-height-page-default" fxLayout="column" fxLayoutGap="16px">
            <div class="atoku-filter-bar" fxLayout="row wrap" fxLayoutAlign="start center" fxLayoutGap="16px">
                <mat-form-field appearance="outline" class="custom-text-field atoku-search-field" floatLabel="always">
                    <mat-label>Search users</mat-label>
                    <input matInput (keyup)="applyFilter($event)" placeholder="Name, email, status">
                    <mat-icon matSuffix>search</mat-icon>
                </mat-form-field>
            </div>

            <div class="table-card mat-elevation-z3" fxLayout="column">
                <div class="table-wrapper" fxFlexOffset="12px">
                    <table mat-table [dataSource]="dataSource" class="custom-table">
                        <ng-container matColumnDef="name">
                            <th mat-header-cell *matHeaderCellDef>User</th>
                            <td mat-cell *matCellDef="let user">
                                <button mat-button color="primary" (click)="selectUser(user)">{{ user.name }}</button>
                            </td>
                        </ng-container>

                        <ng-container matColumnDef="email">
                            <th mat-header-cell *matHeaderCellDef>Email</th>
                            <td mat-cell *matCellDef="let user">{{ user.email }}</td>
                        </ng-container>

                        <ng-container matColumnDef="subscriptionState">
                            <th mat-header-cell *matHeaderCellDef>Subscription</th>
                            <td mat-cell *matCellDef="let user">
                                <span class="atoku-status-pill" [ngClass]="getSubscriptionPill(user).chipClass">
                                    <mat-icon [class.material-icons-outlined]="getSubscriptionPill(user).outlined !== false">
                                        {{ getSubscriptionPill(user).icon }}
                                    </mat-icon>
                                    <span class="footer-default">{{ getSubscriptionPill(user).label }}</span>
                                </span>
                            </td>
                        </ng-container>

                        <ng-container matColumnDef="blocked">
                            <th mat-header-cell *matHeaderCellDef>Blocked</th>
                            <td mat-cell *matCellDef="let user">
                                <span class="atoku-status-pill" [ngClass]="getBlockedPill(user).chipClass">
                                    <mat-icon [class.material-icons-outlined]="getBlockedPill(user).outlined !== false">
                                        {{ getBlockedPill(user).icon }}
                                    </mat-icon>
                                    <span class="footer-default">{{ getBlockedPill(user).label }}</span>
                                </span>
                            </td>
                        </ng-container>

                        <ng-container matColumnDef="entriesToday">
                            <th mat-header-cell *matHeaderCellDef>Entries Today</th>
                            <td mat-cell *matCellDef="let user">{{ user.entriesToday }}</td>
                        </ng-container>

                        <ng-container matColumnDef="lastEntryAt">
                            <th mat-header-cell *matHeaderCellDef>Last Entry</th>
                            <td mat-cell *matCellDef="let user">{{ getLastEntryLabel(user) }}</td>
                        </ng-container>

                        <ng-container matColumnDef="actions">
                            <th mat-header-cell *matHeaderCellDef>Actions</th>
                            <td mat-cell *matCellDef="let user">
                                <div fxLayout="row wrap" fxLayoutGap="8px">
                                    <button mat-stroked-button color="primary" (click)="toggleSubscription(user)"
                                        [disabled]="user.subscriptionState === 'NaN'">
                                        {{ user.subscriptionState === 'subscribed' ? 'Unsubscribe' : 'Subscribe' }}
                                    </button>
                                    <button mat-stroked-button color="warn" *ngIf="user.blocked === false" (click)="blockUser(user)">
                                        Block
                                    </button>
                                    <button mat-stroked-button *ngIf="user.blocked === true" (click)="unblockUser(user)">
                                        Unblock
                                    </button>
                                </div>
                            </td>
                        </ng-container>

                        <tr mat-header-row class="custom-table-header" *matHeaderRowDef="displayedColumns"></tr>
                        <tr mat-row *matRowDef="let row; columns: displayedColumns;"
                            (click)="selectUser(row)" [class.selected-row]="selectedUser?.id === row.id"></tr>
                    </table>
                </div>

                <mat-paginator [pageSize]="10" [pageSizeOptions]="[5, 10, 25]"></mat-paginator>
            </div>

        </div>
    </div>
</div>
